module.exports = __webpack_public_path__ + "static/media/TJ-Date.3f0edb27.svg";